import { useRouter } from 'next/router'
import styles from './BackButton.module.scss'

export default function BackButton() {
  const router = useRouter()

  return (
    <div className={styles.wrap}>
      <p role="button" onClick={() => router.back()} className={styles.back}>
        Takaisin
      </p>
    </div>
  )
}
